import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["type"];
var _allIcons;
import React from 'react';
import { IconAllergy, IconEdit, IconEmail, IconImmunization, IconInsurance, IconLock, IconLumaPay, IconMedicalCondition, IconMedication, IconPerson, IconPharmacy, IconPhone, IconProcedure, useTheme } from '@lumahealthhq/ui-core';
import { IconDemographics, IconSignature, IconSocialHistory } from './iconsCustom';
import { IconAssignmentInd, IconBusiness, IconCheckBox, IconCode, IconEvent, IconEventRepeat, IconFullscreen, IconKeyboardArrowDown, IconList, IconLowPriority, IconMyLocation, IconNotes, IconPlayArrow, IconPriceChange, IconShortText, IconToday, IconTonality } from './iconsMaterial';
import { jsx as _jsx } from "react/jsx-runtime";
var allIcons = (_allIcons = {
  medication_search: IconMedication,
  medication_list: IconMedication,
  immunization_history: IconImmunization,
  allergy: IconAllergy,
  surgical_history: IconProcedure,
  family_history: IconMedicalCondition,
  social_history: IconSocialHistory,
  demographics: IconDemographics,
  docusign_templates: IconSignature,
  insurance_verification: IconInsurance,
  insurance_capture: IconInsurance,
  template_welcome: IconPlayArrow,
  multiple_choice: IconCheckBox,
  yes_no: IconTonality,
  dropdown: IconKeyboardArrowDown,
  short_text: IconShortText,
  long_text: IconNotes,
  email: IconEmail,
  phone_number: IconPhone
}, _defineProperty(_allIcons, 'resources', IconBusiness), _defineProperty(_allIcons, "date", IconToday), _defineProperty(_allIcons, "address", IconMyLocation), _defineProperty(_allIcons, "ssn", IconAssignmentInd), _defineProperty(_allIcons, "zipcode", IconMyLocation), _defineProperty(_allIcons, "pharmacy_search", IconPharmacy), _defineProperty(_allIcons, "e_signature", IconEdit), _defineProperty(_allIcons, "template", IconCode), _defineProperty(_allIcons, '2FA', IconLock), _defineProperty(_allIcons, "patient_information", IconPerson), _defineProperty(_allIcons, "group", IconList), _defineProperty(_allIcons, "jump", IconLowPriority), _defineProperty(_allIcons, "information_capture", IconFullscreen), _defineProperty(_allIcons, "insurance_card", IconFullscreen), _defineProperty(_allIcons, "copay", IconLumaPay), _defineProperty(_allIcons, "payment", IconLumaPay), _defineProperty(_allIcons, "payer", IconLumaPay), _defineProperty(_allIcons, 'insurance_eligibility', IconPriceChange), _defineProperty(_allIcons, 'scheduler', IconEvent), _defineProperty(_allIcons, 'manageAppointment', IconEventRepeat), _allIcons);
export default function IconPatientFormQuestion(_ref) {
  var type = _ref.type,
    rest = _objectWithoutProperties(_ref, _excluded);
  var QuestionIcon = allIcons[type];
  var theme = useTheme();
  if (QuestionIcon) {
    return /*#__PURE__*/_jsx(QuestionIcon, _extends({
      fill: theme.palette.common.black,
      color: "primary"
    }, rest));
  }
  return null;
}